import { Link } from "react-router-dom";
import { useSite } from "@/components/site/SiteLayout";
import useSeo from "@/hooks/useSeo";
import { IconCheck, IconLayers, IconShield } from "@/components/site/icons";

export default function ChiSiamo() {
  const c = useSite();
  useSeo("Chi Siamo", "Esperienza e innovazione al servizio delle reti: scopri chi è POWERCOM, i suoi valori e il modo di lavorare nelle telecomunicazioni e negli impianti tecnologici.");
  return (
    <>
      <section className="page-hero">
        <div className="container reveal">
          <span className="eyebrow light">Chi Siamo</span>
          <h1>Esperienza e innovazione al servizio delle reti.</h1>
          <p>Un team di professionisti dedicato a costruire infrastrutture affidabili e impianti sicuri.</p>
        </div>
      </section>

      <section className="section">
        <div className="container split">
          <div className="split-img reveal">
            <img src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="Team POWERCOM" />
          </div>
          <div className="split-text reveal">
            <span className="eyebrow">La nostra realtà</span>
            <h2>{c.about_title}</h2>
            <p>{c.about_p1}</p>
            <p>{c.about_p2}</p>
            <ul className="ticks">
              {(c.about_points || []).map((p, i) => <li key={i}>{p}</li>)}
            </ul>
          </div>
        </div>
      </section>

      <section className="section section-soft">
        <div className="container">
          <div className="section-head reveal">
            <span className="eyebrow">I nostri valori</span>
            <h2>I principi che guidano il nostro lavoro.</h2>
          </div>
          <div className="cards">
            <article className="card reveal"><div className="ico"><IconCheck /></div><h3>Affidabilità</h3><p>Rispettiamo tempi e impegni presi, garantendo continuità del servizio.</p></article>
            <article className="card reveal"><div className="ico"><IconLayers /></div><h3>Competenza</h3><p>Formazione continua e aggiornamento costante sulle nuove tecnologie.</p></article>
            <article className="card reveal"><div className="ico"><IconShield /></div><h3>Sicurezza</h3><p>Massimo rispetto delle normative a tutela di persone e impianti.</p></article>
          </div>
        </div>
      </section>

      <section className="cta">
        <div className="container cta-inner reveal">
          <h2>Vuoi saperne di più?</h2>
          <p>Siamo a disposizione per illustrarti come possiamo aiutarti.</p>
          <Link to="/contatti" className="btn btn-light">Contattaci</Link>
        </div>
      </section>
    </>
  );
}
